// Company logos shown on each chapter.
import { STOPS } from './stops.js';

// company logos shown at the top of each chapter (Aradoxa's is white, so it sits on a dark chip)
const LOGO = {
  aradoxa: { src: 'assets/logos/aradoxa.png', dark: true },
  welocalize: { src: 'assets/logos/welocalize.png' },
  welodata: { src: 'assets/logos/welodata.png' },
};
[
  null,
  LOGO.aradoxa,
  LOGO.welocalize,
  LOGO.welocalize,
  LOGO.welodata,
  LOGO.welocalize,
  null,
].forEach((l, i) => (STOPS[i].logo = l));
